// import React, { useEffect } from "react";
// import AOS from "aos";
// import "aos/dist/aos.css";
// import background from "../../assets/InnovativeLeadershipBackground.png";
// import img1 from "../../assets/image1.png";
// import img2 from "../../assets/image2.png";
// import img3 from "../../assets/image3.png";
// import img4 from "../../assets/image4.png";

// const LeadershipCard = ({ image, name, data, index }) => {
//   return (
//     <div
//       className="bg-white rounded-lg p-4 sm:p-6 lg:p-8 shadow-sm hover:shadow-xl transition-shadow duration-300 border-b-[7px] border-[#00C7BE] h-full"
//       data-aos="fade-up"
//       data-aos-delay={index * 200}
//     >
//       <div className="flex flex-col space-y-4">
//         <div
//           className="w-10 h-10 sm:w-12 sm:h-12"
//           data-aos="zoom-in"
//           data-aos-delay={index * 300}
//         >
//           <img
//             src={image}
//             alt={name}
//             className="w-full h-full object-contain"
//           />
//         </div>

//         <h3
//           className="text-lg sm:text-xl lg:text-2xl font-semibold text-gray-800 dmsans"
//           data-aos="fade-right"
//           data-aos-delay={index * 400}
//         >
//           {name}
//         </h3>

//         <p
//           className="text-sm sm:text-base lg:text-lg text-gray-600 leading-relaxed heebo"
//           data-aos="fade-left"
//           data-aos-delay={index * 500}
//         >
//           {data}
//         </p>
//       </div>
//     </div>
//   );
// };

// const Allleadership = () => {
//   useEffect(() => {
//     AOS.init({
//       duration: 1000,
//       easing: "ease-in-out",
//       once: false,
//     });
//   }, []);

//   const datas = [
//     {
//       image: img1,
//       name: "Vision-Driven Approach :",
//       data: "With a forward-looking vision, he continues to explore groundbreaking systems, emphasizing accessibility, efficiency, and regional relevance.",
//     },
//     {
//       image: img4,
//       name: "Collaboration & Knowledge Exchange:",
//       data: "His recent visit to the University of Hasselt, Belgium, for the gait analysis rehabilitation system, highlights his dedication to adopting global research for local implementation.",
//     },
//     {
//       image: img3,
//       name: "Regional Impact :",
//       data: "Plans are underway to introduce the gait analysis rehabilitation system to Eastern India with pragmatic compromises to align with regional needs while maintaining quality..",
//     },
//     {
//       image: img2,
//       name: "Motivation & Future Focus :",
//       data: "Sailesh Dani remains committed to fostering innovation and exchanging ideas, ensuring that his work brings sustainable value to the industries he serves and the communities he impacts",
//     },
//   ];

//   return (
//     <section
//       className="w-full bg-cover bg-center bg-no-repeat py-6 sm:py-8 lg:py-10"
//       style={{ backgroundImage: `url(${background})` }}
//     >
//       <div className="w-full bg-[#E6F7F6] px-4 sm:px-6 lg:px-8 py-8 sm:py-12 lg:py-16">
//         <div className="container mx-auto">
//           <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 lg:gap-12">
//             {datas.map((item, index) => (
//               <LeadershipCard
//                 key={index}
//                 image={item.image}
//                 name={item.name}
//                 data={item.data}
//                 index={index}
//               />
//             ))}
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Allleadership;

import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import background from "../../assets/InnovativeLeadershipBackground.png";
import img1 from "../../assets/image1.png";
import img2 from "../../assets/image2.png";
import img3 from "../../assets/image3.png";
import img4 from "../../assets/image4.png";

import { GiMicroscope } from "react-icons/gi";
import { RiFlaskLine } from "react-icons/ri";
import { FaGlobeAmericas } from "react-icons/fa";
import { MdFlag } from "react-icons/md";
import { BsShieldCheck } from "react-icons/bs";

const LeadershipCard = ({ image, name, data, index }) => {
  return (
    <div
      className="bg-white rounded-lg p-4 sm:p-6 lg:p-8 shadow-sm hover:shadow-xl transition-shadow duration-300 border-b-[7px] border-[#00C7BE] h-full"
      data-aos="fade-up"
      data-aos-delay={index * 200}
    >
      <div className="flex flex-col space-y-4">
        <div className="w-10 h-10 sm:w-12 sm:h-12" data-aos="zoom-in">
          {typeof image === "string" ? (
            <img
              src={image}
              alt={name}
              className="w-full h-full object-contain"
            />
          ) : (
            <div className="text-[#00C7BE] w-full h-full text-4xl flex items-center justify-center">
              {image}
            </div>
          )}
        </div>

        <h3 className="text-lg sm:text-xl lg:text-2xl font-semibold text-gray-800 dmsans">
          {name}
        </h3>

        <p className="text-sm sm:text-base lg:text-lg text-gray-600 leading-relaxed heebo">
          {data}
        </p>
      </div>
    </div>
  );
};

const Allleadership = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: false,
    });
  }, []);

  const datas = [
    {
      image: img1,
      name: "Vision-Driven Approach :",
      data: "With a forward-looking vision, he continues to explore groundbreaking systems, emphasizing accessibility, efficiency, and regional relevance.",
    },
    {
      image: img4,
      name: "Collaboration & Knowledge Exchange :",
      data: "His recent visit to the University of Hasselt, Belgium, for the gait analysis rehabilitation system, highlights his dedication to adopting global research for local implementation.",
    },
    {
      image: img3,
      name: "Regional Impact :",
      data: "Plans are underway to introduce the gait analysis rehabilitation system to Eastern India with pragmatic compromises to align with regional needs while maintaining quality.",
    },
    {
      image: img2,
      name: "Motivation & Future Focus :",
      data: "Sailesh Dani remains committed to fostering innovation and exchanging ideas, ensuring that his work brings sustainable value to the industries he serves and the communities he impacts.",
    },

    {
      image: <MdFlag />,
      name: "His Mission :",
      data: `To democratize high-quality learning by integrating global technology into India’s medical colleges and regional schools, ensuring every student gains access to premium tools and immersive educational experiences.`,
    },
    {
      image: <BsShieldCheck />,
      name: "His Commitment :",
      data: `Dedicated to continuous innovation, global technology adoption, strengthening India’s academic ecosystem, supporting institutions with impactful solutions, and empowering students to excel in a competitive world.`,
    },
  ];

  return (
    <section
      className="w-full bg-cover bg-center bg-no-repeat py-6 sm:py-8 lg:py-10"
      style={{ backgroundImage: `url(${background})` }}
    >
      <div className="w-full bg-[#E6F7F6] px-4 sm:px-6 lg:px-8 py-8 sm:py-12 lg:py-16">
        <div className="container mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 lg:gap-12 justify-items-center">
            {datas.map((item, index) => (
              <LeadershipCard
                key={index}
                image={item.image}
                name={item.name}
                data={item.data}
                index={index}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Allleadership;
